export default "__VITE_ASSET__Cyo_OU$S__"